import { GET_ORDER_INFO } from '../actionTypes/CartActionTypes';

export const getOrderInfo = (payload) => ({
    type: GET_ORDER_INFO,
    payload,
});

export default { getOrderInfo };
